export default "__VITE_ASSET__CBvq9cBl__"